// modules/DisplayAllLots.js
import React         from 'react';
import DisplayLotRow          from './DisplayLotRow';
import LotHeading   from './LotHeading';

class DisplayAllLots extends React.Component {
	render() {
		if (this.props.lots.filteredlots !== null && this.props.lots.filteredlots.length > 0) {
			return (
				<div>
					<LotHeading></LotHeading>
					{this.props.state.map((lot, idx) => {
						return (
							<DisplayLotRow key={idx} lot={lot} />
						)
					})}
				</div>
			);
		} else{
			return (
				<div className="noResult">
					No Land found within your desired search <br/>
					Please expand search criteria.
				</div>
			)
		}
	}
}

export default DisplayAllLots;


/** WEBPACK FOOTER **
 ** ./src/modules/common/DisplayAllLots.js
 **/